import { type GridApi } from '@ag-grid-community/core';
import { Card } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';
import { RequestsHeader } from './RequestsHeader/RequestsHeader';
import { RequestsTable } from './RequestsTable/RequestsTable';

interface RequestsCardProps {
    requests: ComponentCreateRequestMapped[];
    selectedChange: (request: ComponentCreateRequestMapped) => void;
    gridReady: (api: GridApi<ComponentCreateRequestMapped>) => void;
}

export function RequestsCard({
    requests,
    selectedChange,
    gridReady,
}: RequestsCardProps): ReactNode {
    return (
        <Card title="Requests" className="flex flex-column gap-4">
            <RequestsHeader requests={requests} />
            <RequestsTable
                requests={requests}
                selectedChange={selectedChange}
                gridReady={gridReady}
            />
        </Card>
    );
}
